import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";
import { applyGlitch } from "../engine/effects.js";

/**
 * GlitchNode
 * ----------
 * Displaces horizontal slices of the canvas with optional RGB channel offset.
 */
export class GlitchNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Glitch";

    this.properties = {
      intensity: 0.5,
      sliceCount: 8,
      rgbOffset: 3,
      seed: 0,
    };

    this.addInput("Canvas", "canvas");
    this.addOutput("Canvas", "canvas");

    addDrivableSlider(this, "Intensity", "intensity", 0.5, 0, 1, 0.01);
    addDrivableSlider(this, "Slices", "sliceCount", 8, 1, 40, 1);
    addDrivableSlider(this, "RGB Offset", "rgbOffset", 3, 0, 30, 1);

    finalizeDrivableSliders(this, 1);

    this._outCanvas = document.createElement("canvas");
    this._outCtx = this._outCanvas.getContext("2d");

    this.size = [200, 110];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    syncDrivableSliders(this);

    const input = this.getInputData(0);
    if (!input) { this.setOutputData(0, null); return; }

    const w = input.width;
    const h = input.height;
    if (this._outCanvas.width !== w) this._outCanvas.width = w;
    if (this._outCanvas.height !== h) this._outCanvas.height = h;

    const ctx = this._outCtx;
    const { intensity, sliceCount, rgbOffset } = this.properties;

    // Advance seed for animation
    this.properties.seed += 0.1;
    const seed = this.properties.seed;

    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(input, 0, 0);

    applyGlitch(ctx, w, h, { intensity, sliceCount, rgbOffset, seed });

    this.setOutputData(0, this._outCanvas);
  }
}

LiteGraph.registerNodeType("effects/Glitch", GlitchNode);
